exports.components = {
  "component---src-components-home-index-js": () => import("./../../../src/components/Home/index.js" /* webpackChunkName: "component---src-components-home-index-js" */),
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */)
}

